import { createActionGroup, props } from '@ngrx/store';

export const LangActions = createActionGroup({
  source: 'Langs',
  events: {
    'Load langs': props<{ payload: { aliases: {name: string, locale: string}[], locale?: string } }>(),
    'Load langs success': props<{ langs: Record<string, string>, reg_locale?: string }>(),
    'Load langs failure': props<{ payload: unknown }>(),
  },
});

export type LoadLangAction = ReturnType<typeof LangActions.loadLangs>;
export type LoadLangSuccessAction = ReturnType<typeof LangActions.loadLangsSuccess>;
export type LoadLangFailureAction = ReturnType<typeof LangActions.loadLangsFailure>;
